import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: string;
  title: string;
  message?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-background-200 bg-white px-6 py-14 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-secondary-500">
        <i className={`${icon} text-3xl`} aria-hidden="true"></i>
      </span>
      <h3 className="mt-4 font-semibold text-base text-foreground-950">{title}</h3>
      {message && (
        <p className="mt-1.5 max-w-[380px] text-[13px] leading-relaxed text-foreground-500">
          {message}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}